// ============================================================
// EAU PERFUMERÍA
// SELECTOR VISUAL DE ENVASES CON VIDEOS
// VERSIÓN CORREGIDA
// ============================================================

(function () {
    'use strict';

    console.log(
        '🎬 EAU Envases - iniciando'
    );

    // ============================================================
    // 1. VIDEOS
    // ============================================================

    const envaseVideosDama = {

        '50 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/4a23f31b5c0542c7a67fe99f5d2d6e20.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/d673984ee053429c8ec381c1a3e7c0f3.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/a16027e4ec344161bad111dbd3f25b62.mp4'
            }
        ],

        '65 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/46c3d5e9e9d9486987054faf4f017c93.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/a11302075ce34dc487ce3e31da55cb48.mp4'
            },
            // {
            //    src: 'https://cdn.shopify.com/videos/c/o/v/2f674619c3374e7f8ea24784c7987575.mp4'
            // }
        ],

        '80 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/933d35bd86594d8481f9012417e8afca.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/eb19946e388141a0946cc7532841eca4.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/30133c3b536c40baaf70e1d9e4ff92d0.mp4'
            }
        ],

        '100 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/50928de3973d41a19ea84c99080f1337.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/549e87b373e44fe8b5bca668b8120c89.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/627d232fec5042219c392526b4052ff7.mp4'
            }
        ]
    };

    const envaseVideosCaballero = {

        '50 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/44c8187b5daa4658b9296958c91b0235.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/be3dd56caa4740638832867b08f814c8.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/3331917c317d44629b5c02cb1c117fd5.mp4'
            }
        ],

        '65 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/910794fbf4fa483fb43cdd1a95299433.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/751ee422db994953b7b0b95d427aad3a.mp4'
            },
            // {
            //    src: 'https://cdn.shopify.com/videos/c/o/v/751ee422db994953b7b0b95d427aad3a.mp4'
            // }
        ],

        '80 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/eb19946e388141a0946cc7532841eca4.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/7b4ae8fb952f41fb8eec2d27ab423af4.mp4'
            },
            // {
            //    src: 'https://cdn.shopify.com/videos/c/o/v/eb19946e388141a0946cc7532841eca4.mp4'
            // }
        ],

        '100 ml': [
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/c53e3b814fa44ce283e4cd330f2135d6.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/8339f971b38f42878db94dee79816f82.mp4'
            },
            {
                src: 'https://cdn.shopify.com/videos/c/o/v/766b3e19c82c4ecb87a00ef2b5389ee5.mp4'
            }
        ]
    };

    const envaseVideosUnisex = {

        '50 ml': {
            dama:
                envaseVideosDama['50 ml'],
            caballero:
                envaseVideosCaballero['50 ml']
        },

        '65 ml': {
            dama:
                envaseVideosDama['65 ml'],
            caballero:
                envaseVideosCaballero['65 ml']
        },

        '80 ml': {
            dama:
                envaseVideosDama['80 ml'],
            caballero:
                envaseVideosCaballero['80 ml']
        },

        '100 ml': {
            dama:
                envaseVideosDama['100 ml'],
            caballero:
                envaseVideosCaballero['100 ml']
        }
    };

    // ============================================================
    // 2. ESTADO
    // ============================================================

    const state = {

        productData: null,

        category: null,

        size: null,

        envase: null,

        concentration: null,

        gender: null,

        initialized: false,

        rendering: false,

        refreshTimer: null
    };

    // ============================================================
    // 3. UTILIDADES
    // ============================================================

    function normalize(value) {

        return String(value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(
                /[\u0300-\u036f]/g,
                ''
            )
            .replace(
                /[^a-z0-9]/g,
                ''
            );
    }

    function getProductData() {

        try {

            const element =
                document.querySelector(
                    '[id^="eau-product-data-"]'
                );

            if (!element) {

                console.warn(
                    '⚠️ No se encontró eau-product-data'
                );

                return null;
            }

            return JSON.parse(
                element.textContent || '{}'
            );

        } catch (error) {

            console.error(
                '❌ Error leyendo datos del producto:',
                error
            );

            return null;
        }
    }

    // ============================================================
    // CATEGORÍA
    // ============================================================

    function getActiveCategory() {

        const data =
            state.productData ||
            getProductData();

        if (!data) {
            return null;
        }

        const productType =
            normalize(
                data.productType
            );

        if (
            productType ===
            'perfumemasculino'
        ) {

            return 'caballero';
        }

        if (
            productType ===
            'perfumefemenino'
        ) {

            return 'dama';
        }

        if (
            productType ===
            'perfumeunisex'
        ) {

            return 'unisex';
        }

        // --------------------------------------------------------
        // IMPORTANTE
        // --------------------------------------------------------
        // Cualquier otro tipo de producto NO utiliza
        // el selector personalizado de envases.
        // --------------------------------------------------------

        return null;
    }

    function isSupportedCategory() {

        return (
            state.category === 'dama' ||
            state.category === 'caballero' ||
            state.category === 'unisex'
        );
    }

    // ============================================================
    // OPCIONES SHOPIFY
    // ============================================================

    function getOptionIndex(name) {

        const data =
            state.productData;

        if (
            !data ||
            !Array.isArray(data.options)
        ) {

            return -1;
        }

        const wanted =
            normalize(name);

        return data.options.findIndex(
            function (optionName) {

                return (
                    normalize(optionName) ===
                    wanted
                );
            }
        );
    }

    function getCurrentVariant() {

        const data =
            state.productData;

        if (
            !data ||
            !Array.isArray(data.variants)
        ) {

            return null;
        }

        const select =
            document.querySelector(
                'select[name="id"]'
            );

        if (
            !select ||
            !select.value
        ) {

            return null;
        }

        return (
            data.variants.find(
                function (variant) {

                    return (
                        String(variant.id) ===
                        String(select.value)
                    );
                }
            ) || null
        );
    }

    // ============================================================
    // OBTENER VALOR SELECCIONADO
    // ============================================================

    function getSelectedOption(
        optionName
    ) {

        const index =
            getOptionIndex(
                optionName
            );

        if (index < 0) {
            return null;
        }

        const wantedName =
            normalize(
                optionName
            );

        const wrappers =
            document.querySelectorAll(
                '[data-opname]'
            );

        for (
            let i = 0;
            i < wrappers.length;
            i++
        ) {

            const wrapper =
                wrappers[i];

            if (
                normalize(
                    wrapper.getAttribute(
                        'data-opname'
                    )
                ) !== wantedName
            ) {

                continue;
            }

            // SELECT
            const select =
                wrapper.querySelector(
                    'select'
                );

            if (select) {

                const selectedOption =
                    select.options[
                        select.selectedIndex
                    ];

                if (selectedOption) {

                    const value =
                        selectedOption.getAttribute(
                            'value'
                        ) ||
                        selectedOption.textContent ||
                        '';

                    if (
                        String(value).trim()
                    ) {

                        return String(
                            value
                        ).trim();
                    }
                }
            }

            // SWATCH
            const selected =
                wrapper.querySelector(
                    'li.is-selected-nt'
                );

            if (selected) {

                const value =
                    selected.getAttribute(
                        'data-value'
                    ) ||
                    selected.textContent ||
                    '';

                if (
                    String(value).trim()
                ) {

                    return String(
                        value
                    ).trim();
                }
            }
        }

        // --------------------------------------------------------
        // BÚSQUEDA ALTERNATIVA POR ÍNDICE
        // --------------------------------------------------------

        const selectors = [

            'select[data-id="' +
            index +
            '"]',

            'select[data-index="' +
            index +
            '"]',

            'select[name="option' +
            (index + 1) +
            '"]',

            'select[name="options[' +
            index +
            ']"]',

            '.swatch ul[data-id="' +
            index +
            '"]'
        ];

        for (
            let i = 0;
            i < selectors.length;
            i++
        ) {

            const element =
                document.querySelector(
                    selectors[i]
                );

            if (!element) {
                continue;
            }

            if (
                element.tagName ===
                'SELECT'
            ) {

                const selectedOption =
                    element.options[
                        element.selectedIndex
                    ];

                if (selectedOption) {

                    const value =
                        selectedOption.value ||
                        selectedOption.textContent ||
                        '';

                    if (
                        String(value).trim()
                    ) {

                        return String(
                            value
                        ).trim();
                    }
                }
            }

            const selected =
                element.querySelector(
                    'li.is-selected-nt'
                );

            if (selected) {

                const value =
                    selected.getAttribute(
                        'data-value'
                    ) ||
                    selected.textContent ||
                    '';

                if (
                    String(value).trim()
                ) {

                    return String(
                        value
                    ).trim();
                }
            }
        }

        // --------------------------------------------------------
        // ÚLTIMO RECURSO: VARIANTE SHOPIFY
        // --------------------------------------------------------

        const variant =
            getCurrentVariant();

        if (variant) {

            const variantValue =
                variant[
                    'option' +
                    (index + 1)
                ];

            if (variantValue) {

                return String(
                    variantValue
                ).trim();
            }
        }

        return null;
    }

    // ============================================================
    // 4. DETECTAR OPCIONES
    // ============================================================

    function detectSize() {

        const value =
            getSelectedOption(
                'Tamaño'
            );

        const sizes = [
            '50 ml',
            '65 ml',
            '80 ml',
            '100 ml'
        ];

        if (value) {

            const clean =
                normalize(value);

            for (
                let i = 0;
                i < sizes.length;
                i++
            ) {

                if (
                    normalize(
                        sizes[i]
                    ) === clean
                ) {

                    return sizes[i];
                }
            }
        }

        const variant =
            getCurrentVariant();

        const index =
            getOptionIndex(
                'Tamaño'
            );

        if (
            variant &&
            index >= 0
        ) {

            const variantValue =
                variant[
                    'option' +
                    (index + 1)
                ];

            const clean =
                normalize(
                    variantValue
                );

            for (
                let i = 0;
                i < sizes.length;
                i++
            ) {

                if (
                    normalize(
                        sizes[i]
                    ) === clean
                ) {

                    return sizes[i];
                }
            }
        }

        return null;
    }

    function detectEnvase() {

        const value =
            getSelectedOption(
                'Envase'
            );

        if (!value) {
            return null;
        }

        const clean =
            normalize(value);

        if (
            clean === 'modelo1'
        ) {

            return 'modelo-1';
        }

        if (
            clean === 'modelo2'
        ) {

            return 'modelo-2';
        }

        if (
            clean === 'modelo3'
        ) {

            return 'modelo-3';
        }

        return null;
    }

    function detectConcentration() {

        const value =
            getSelectedOption(
                'Concentración del perfume'
            );

        if (value) {
            return value;
        }

        const variant =
            getCurrentVariant();

        const index =
            getOptionIndex(
                'Concentración del perfume'
            );

        if (
            variant &&
            index >= 0
        ) {

            return (
                variant[
                    'option' +
                    (index + 1)
                ] || null
            );
        }

        return null;
    }

    // ============================================================
    // VIDEOS ACTUALES
    // ============================================================

    function getCurrentVideos() {

        if (!isSupportedCategory()) {
            return [];
        }

        if (!state.size) {
            return [];
        }

        if (
            state.category ===
            'dama'
        ) {

            return (
                envaseVideosDama[
                    state.size
                ] || []
            );
        }

        if (
            state.category ===
            'caballero'
        ) {

            return (
                envaseVideosCaballero[
                    state.size
                ] || []
            );
        }

        if (
            state.category ===
            'unisex'
        ) {

            if (!state.gender) {
                return [];
            }

            return (
                envaseVideosUnisex[
                    state.size
                ]?.[
                    state.gender
                ] || []
            );
        }

        return [];
    }

    // ============================================================
    // 5. VARIANTES SHOPIFY
    // ============================================================

    function findVariant(
        size,
        envase,
        concentration
    ) {

        const data =
            state.productData;

        if (
            !data ||
            !Array.isArray(
                data.variants
            )
        ) {

            return null;
        }

        const sizeIndex =
            getOptionIndex(
                'Tamaño'
            );

        const envaseIndex =
            getOptionIndex(
                'Envase'
            );

        const concentrationIndex =
            getOptionIndex(
                'Concentración del perfume'
            );

        if (
            sizeIndex < 0 ||
            envaseIndex < 0 ||
            concentrationIndex < 0
        ) {

            return null;
        }

        const wantedSize =
            normalize(size);

        const wantedEnvase =
            normalize(
                String(envase)
                    .replace(
                        /-/g,
                        ' '
                    )
            );

        const wantedConcentration =
            normalize(
                concentration
            );

        return (
            data.variants.find(
                function (variant) {

                    const variantSize =
                        variant[
                            'option' +
                            (sizeIndex + 1)
                        ];

                    const variantEnvase =
                        variant[
                            'option' +
                            (envaseIndex + 1)
                        ];

                    const variantConcentration =
                        variant[
                            'option' +
                            (concentrationIndex + 1)
                        ];

                    return (
                        normalize(
                            variantSize
                        ) === wantedSize &&

                        normalize(
                            variantEnvase
                        ) === wantedEnvase &&

                        normalize(
                            variantConcentration
                        ) ===
                        wantedConcentration
                    );
                }
            ) || null
        );
    }

    function setNativeVariant(
        variantId
    ) {

        if (!variantId) {
            return false;
        }

        const select =
            document.querySelector(
                'select[name="id"]'
            );

        if (!select) {

            console.warn(
                '⚠️ No existe select[name="id"]'
            );

            return false;
        }

        select.value =
            String(variantId);

        select.dispatchEvent(
            new Event(
                'change',
                {
                    bubbles: true
                }
            )
        );

        select.dispatchEvent(
            new Event(
                'input',
                {
                    bubbles: true
                }
            )
        );

        console.log(
            '✅ Variante Shopify seleccionada:',
            variantId
        );

        return true;
    }

    function selectEnvase(
    envase
) {

    if (!isSupportedCategory()) {
        return;
    }

    /*
     * ========================================================
     * 1. OBTENER LA VARIANTE REAL ACTUAL
     * ========================================================
     */

    const currentVariant =
        getCurrentVariant();

    if (!currentVariant) {
        console.warn(
            '⚠️ No se pudo obtener la variante actual'
        );
        return;
    }


    /*
     * ========================================================
     * 2. OBTENER LOS VALORES ACTUALES
     * ========================================================
     *
     * MUY IMPORTANTE:
     * Conservamos la concentración que el cliente
     * acaba de seleccionar.
     */

    const sizeIndex =
        getOptionIndex(
            'Tamaño'
        );

    const concentrationIndex =
        getOptionIndex(
            'Concentración del perfume'
        );


    const currentSize =
        sizeIndex >= 0
            ? currentVariant[
                'option' +
                (sizeIndex + 1)
            ]
            : state.size;


    const currentConcentration =
        concentrationIndex >= 0
            ? currentVariant[
                'option' +
                (concentrationIndex + 1)
            ]
            : state.concentration;


    if (!currentSize) {
        console.warn(
            '⚠️ No hay tamaño seleccionado'
        );
        return;
    }


    if (!currentConcentration) {
        console.warn(
            '⚠️ No hay concentración seleccionada'
        );
        return;
    }


    /*
     * ========================================================
     * 3. BUSCAR LA VARIANTE EXACTA
     * ========================================================
     *
     * AHORA SÍ:
     *
     * Tamaño
     * +
     * Envase
     * +
     * Concentración
     *
     * Esto evita que al cambiar el envase Shopify
     * vuelva accidentalmente a "Super concentrado".
     */

    const variant =
        findVariant(
            currentSize,
            envase,
            currentConcentration
        );


    if (!variant) {

        console.warn(
            '⚠️ No se encontró la combinación exacta:',
            {
                tamaño:
                    currentSize,

                envase:
                    envase,

                concentración:
                    currentConcentration
            }
        );

        return;
    }


    /*
     * ========================================================
     * 4. ACTUALIZAR EL ESTADO INTERNO
     * ========================================================
     */

    state.size =
        currentSize;

    state.envase =
        envase;

    state.concentration =
        currentConcentration;


    /*
     * ========================================================
     * 5. SELECCIONAR LA VARIANTE REAL DE SHOPIFY
     * ========================================================
     */

    setNativeVariant(
        variant.id
    );


    /*
     * ========================================================
     * 6. SINCRONIZAR VISUALMENTE EL ENVASE NATIVO
     * ========================================================
     */

    const nativeEnvaseSelectors = [
        '[data-opname="envase"]',
        '[data-opname="Envase"]'
    ];

    let nativeGroup =
        null;

    for (
        let i = 0;
        i < nativeEnvaseSelectors.length;
        i++
    ) {

        nativeGroup =
            document.querySelector(
                nativeEnvaseSelectors[i]
            );

        if (nativeGroup) {
            break;
        }
    }


    if (nativeGroup) {

        const nativeItems =
            nativeGroup.querySelectorAll(
                'li'
            );

        nativeItems.forEach(
            function (item) {

                item.classList.remove(
                    'is-selected',
                    'is-selected-nt'
                );


                const value =
                    (
                        item.getAttribute(
                            'data-value'
                        ) ||
                        item.getAttribute(
                            'data-escape'
                        ) ||
                        item.textContent ||
                        ''
                    )
                    .trim()
                    .toLowerCase();


                const model =
                    String(envase)
                        .trim()
                        .toLowerCase()
                        .replace(
                            /-/g,
                            ''
                        );


                if (
                    value.replace(
                        /-/g,
                        ''
                    ) === model
                ) {

                    item.classList.add(
                        'is-selected'
                    );

                    item.classList.add(
                        'is-selected-nt'
                    );
                }

            }
        );

    }


    /*
     * ========================================================
     * 7. ACTUALIZAR TARJETAS
     * ========================================================
     */

    updateCards();


    /*
     * ========================================================
     * 8. DIAGNÓSTICO
     * ========================================================
     */

    console.log(
        '✅ Envase seleccionado manteniendo concentración:',
        {
            variante:
                variant.id,

            tamaño:
                currentSize,

            envase:
                envase,

            concentración:
                currentConcentration
        }
    );


    /*
     * ========================================================
     * 9. REFORZAR ESTADO VISUAL
     * ========================================================
     */

    setTimeout(
        function () {

            state.size =
                currentSize;

            state.envase =
                envase;

            state.concentration =
                currentConcentration;

            updateCards();

        },
        150
    );

}

    // ============================================================
    // 6. ESTILOS
    // ============================================================

    function createStyles() {

        let style =
            document.getElementById(
                'eau-envase-styles'
            );

        if (!style) {

            style =
                document.createElement(
                    'style'
                );

            style.id =
                'eau-envase-styles';

            document.head.appendChild(
                style
            );
        }

        style.textContent = `

            /*
             * IMPORTANTE:
             * El Envase nativo SOLO se oculta
             * cuando body tiene eau-envase-enabled.
             */

            body.eau-envase-enabled
            [data-opname="envase"],

            body.eau-envase-enabled
            [data-opname="Envase"],

            body.eau-envase-enabled
            .swatch.is-envase,

            body.eau-envase-enabled
            .swatch.is-Envase,

            body.eau-envase-enabled
            .swatch[data-opname*="envase"],

            body.eau-envase-enabled
            div[data-opname*="envase"] {

                display: none !important;
            }

            #eau-envase-selector {

                width: 100%;

                margin:
                    12px 0 18px;

                box-sizing:
                    border-box;
            }

            .eau-envase-heading {

                margin-bottom:
                    10px;
            }

            .eau-envase-title {
    margin: 0 !important;
    padding: 0 !important;

    font-family: inherit !important;
    font-size: 15px !important;
    line-height: 18px !important;
    font-weight: 700 !important;

    color: #182536 !important;

    letter-spacing: 0 !important;
    text-transform: none !important;
    text-align: left !important;
}

            .eau-envase-subtitle {

                margin:
                    3px 0 10px;

                font-size:
                    12px;

                color:
                    #777;
            }

            .eau-envase-gender {

                display:
                    flex;

                gap:
                    8px;

                margin-bottom:
                    10px;
            }

            .eau-gender-button {

                flex:
                    1;

                padding:
                    10px 8px;

                border:
                    1px solid #ddd;

                border-radius:
                    8px;

                background:
                    #fff;

                cursor:
                    pointer;

                font-size:
                    13px;

                font-weight:
                    600;

                transition:
                    all .2s ease;
            }

            .eau-gender-button:hover {

                border-color:
                    #999;
            }

            .eau-gender-button.active {

                background:
                    #33414E;

                color:
                    #fff;

                border-color:
                    #33414E;
            }

            .eau-envase-grid {

                display:
                    grid;

                grid-template-columns:
                    repeat(
                        3,
                        minmax(
                            0,
                            1fr
                        )
                    );

                gap:
                    8px;

                width:
                    100%;
            }

            .eau-envase-card {

                position:
                    relative;

                display:
                    block;

                width:
                    100%;

                padding:
                    0;

                margin:
                    0;

                border:
                    2px solid #e5e5e5;

                border-radius:
                    9px;

                overflow:
                    hidden;

                background:
                    #fff;

                cursor:
                    pointer;

                appearance:
                    none;

                -webkit-appearance:
                    none;

                transition:
                    border-color .18s ease,
                    box-shadow .18s ease,
                    transform .18s ease;
            }

            .eau-envase-card:hover {

                border-color:
                    #999;

                transform:
                    translateY(-1px);
            }

            .eau-envase-card.selected {

                border-color:
                    #33414E;

                box-shadow:
                    0 0 0 1px #33414E;
            }

            .eau-envase-card video {

                display:
                    block;

                width:
                    100%;

                height:
                    auto;

                aspect-ratio:
                    1 / 1;

                object-fit:
                    cover;

                background:
                    #f5f5f5;

                pointer-events:
                    none;
            }

            .eau-envase-card-name {

                padding:
                    7px 4px;

                text-align:
                    center;

                font-size:
                    12px;

                font-weight:
                    700;

                line-height:
                    1.2;

                color:
                    #333;
            }

            .eau-envase-check {

                position:
                    absolute;

                top:
                    6px;

                right:
                    6px;

                width:
                    22px;

                height:
                    22px;

                display:
                    flex;

                align-items:
                    center;

                justify-content:
                    center;

                border-radius:
                    50%;

                background:
                    #33414E;

                color:
                    #fff;

                font-size:
                    12px;

                font-weight:
                    700;

                opacity:
                    0;

                transform:
                    scale(.7);

                transition:
                    opacity .18s ease,
                    transform .18s ease;

                pointer-events:
                    none;
            }

            .eau-envase-card.selected
            .eau-envase-check {

                opacity:
                    1;

                transform:
                    scale(1);
            }

            .eau-envase-message {

                padding:
                    10px;

                border-radius:
                    8px;

                background:
                    #f7f7f7;

                text-align:
                    center;

                color:
                    #777;

                font-size:
                    12px;
            }

            @media (max-width: 480px) {

                .eau-envase-grid {

                    gap:
                        6px;
                }

                .eau-envase-card-name {

                    font-size:
                        11px;
                }
            }
        `;
    }

    // ============================================================
    // RESTAURAR ENVASE NATIVO
    // ============================================================

    function restoreNativeEnvase() {

        try {

            document.body.classList.remove(
                'eau-envase-enabled'
            );

            document
                .querySelectorAll(
                    '[data-eau-original-display]'
                )
                .forEach(
                    function (element) {

                        const originalDisplay =
                            element.getAttribute(
                                'data-eau-original-display'
                            );

                        element.style.removeProperty(
                            'display'
                        );

                        if (originalDisplay) {

                            element.style.display =
                                originalDisplay;
                        }

                        element.removeAttribute(
                            'data-eau-original-display'
                        );
                    }
                );

        } catch (error) {

            console.error(
                '❌ Error restaurando Envase nativo:',
                error
            );
        }
    }

    // ============================================================
    // OCULTAR ENVASE NATIVO
    // ============================================================

    function hideNativeEnvase() {

        if (
            !isSupportedCategory()
        ) {

            restoreNativeEnvase();

            return;
        }

        try {

            const selectors = [

                '[data-opname="envase"]',

                '[data-opname="Envase"]',

                '.swatch.is-envase',

                '.swatch.is-Envase',

                '.swatch[data-opname="envase"]',

                '.swatch[data-opname="Envase"]'
            ];

            selectors.forEach(
                function (selector) {

                    document
                        .querySelectorAll(
                            selector
                        )
                        .forEach(
                            function (element) {

                                if (
                                    element.id ===
                                    'eau-envase-selector'
                                ) {

                                    return;
                                }

                                if (
                                    element.closest(
                                        '#eau-envase-selector'
                                    )
                                ) {

                                    return;
                                }

                                if (
                                    !element.hasAttribute(
                                        'data-eau-original-display'
                                    )
                                ) {

                                    element.setAttribute(
                                        'data-eau-original-display',
                                        element.style.display || ''
                                    );
                                }

                                element.style.setProperty(
                                    'display',
                                    'none',
                                    'important'
                                );
                            }
                        );
                }
            );

            document
                .querySelectorAll(
                    '.swatch[data-opname]'
                )
                .forEach(
                    function (swatch) {

                        if (
                            normalize(
                                swatch.getAttribute(
                                    'data-opname'
                                )
                            ) === 'envase' &&
                            !swatch.closest(
                                '#eau-envase-selector'
                            )
                        ) {

                            if (
                                !swatch.hasAttribute(
                                    'data-eau-original-display'
                                )
                            ) {

                                swatch.setAttribute(
                                    'data-eau-original-display',
                                    swatch.style.display || ''
                                );
                            }

                            swatch.style.setProperty(
                                'display',
                                'none',
                                'important'
                            );
                        }
                    }
                );

            document.body.classList.add(
                'eau-envase-enabled'
            );

        } catch (error) {

            console.error(
                '❌ Error ocultando Envase nativo:',
                error
            );
        }
    }

    // ============================================================
    // 7. LIBERAR VIDEOS
    // ============================================================

    function releaseVideos(
        container
    ) {

        if (!container) {
            return;
        }

        container
            .querySelectorAll(
                'video'
            )
            .forEach(
                function (video) {

                    try {

                        video.pause();

                        video.removeAttribute(
                            'src'
                        );

                        video.removeAttribute(
                            'preload'
                        );

                        video.load();

                    } catch (error) {

                        console.warn(
                            '⚠️ No se pudo liberar un video:',
                            error
                        );
                    }
                }
            );
    }

    // ============================================================
    // 8. CONTROL DE VIDEOS
    // ============================================================

    function loadAndPlayVideo(
        video
    ) {

        if (!video) {
            return;
        }

        if (
            !video.dataset.loaded
        ) {

            const src =
                video.dataset.src;

            if (src) {

                video.src =
                    src;

                video.dataset.loaded =
                    '1';

                video.preload =
                    'auto';
            }
        }

        const promise =
            video.play();

        if (
            promise &&
            typeof promise.catch ===
            'function'
        ) {

            promise.catch(
                function () {}
            );
        }
    }

    function pauseOtherVideos(
        currentVideo
    ) {

        const container =
            document.getElementById(
                'eau-envase-selector'
            );

        if (!container) {
            return;
        }

        container
            .querySelectorAll(
                'video'
            )
            .forEach(
                function (video) {

                    if (
                        video !==
                        currentVideo
                    ) {

                        try {

                            video.pause();

                        } catch (
                            error
                        ) {}
                    }
                }
            );
    }

    function preparePreviewVideo(
    video
) {

    if (!video) {
        return;
    }


    // ============================================================
    // CONFIGURACIÓN DEL VIDEO
    // ============================================================

    video.muted =
        true;

    video.loop =
        true;

    video.playsInline =
        true;


    // ============================================================
    // IMPORTANTE:
    // CARGAR EL VIDEO INMEDIATAMENTE
    // ============================================================

    const src =
        video.dataset.src;

    if (src) {

        video.src =
            src;

        video.preload =
            'auto';

        video.dataset.loaded =
            '1';

        // Fuerza al navegador a comenzar
        // la carga del video inmediatamente.
        video.load();
    }


    // ============================================================
    // ATRIBUTOS NECESARIOS PARA iPHONE / SAFARI
    // ============================================================

    video.setAttribute(
        'muted',
        ''
    );

    video.setAttribute(
        'playsinline',
        ''
    );

    video.setAttribute(
        'webkit-playsinline',
        ''
    );

    video.setAttribute(
        'preload',
        'auto'
    );
}

    // ============================================================
    // 9. CREAR SELECTOR
    // ============================================================

    function createSelector() {

        // --------------------------------------------------------
        // PROTECCIÓN PRINCIPAL
        // --------------------------------------------------------
        // Si NO es perfume, no hacemos absolutamente nada.
        // --------------------------------------------------------

        if (
            !isSupportedCategory()
        ) {

            const existing =
                document.getElementById(
                    'eau-envase-selector'
                );

            if (existing) {

                releaseVideos(
                    existing
                );

                existing.remove();
            }

            restoreNativeEnvase();

            return;
        }

        if (
            state.rendering
        ) {

            return;
        }

        state.rendering =
            true;

        try {

            let container =
                document.getElementById(
                    'eau-envase-selector'
                );

            if (container) {

                renderSelector(
                    container
                );

                return;
            }

            container =
                document.createElement(
                    'div'
                );

            container.id =
                'eau-envase-selector';

            // ============================================================
// POSICIÓN DEL SELECTOR DE ENVASE
// SIEMPRE: después de TAMAÑO y antes de INTENSIDAD
// ============================================================

const sizeBlock =
    document.querySelector('[data-opname="tamano"]') ||
    document.querySelector('[data-opname="tamaño"]');

const intensityBlock =
    document.querySelector('[data-opname="concentracion-del-perfume"]') ||
    document.querySelector('[data-opname="concentraciondelperfume"]');

const nativeEnvase =
    document.querySelector('[data-opname="envase"]') ||
    document.querySelector('[data-opname="Envase"]');

if (sizeBlock && sizeBlock.parentNode) {

    // Lo colocamos inmediatamente después de TAMAÑO
    sizeBlock.parentNode.insertBefore(
        container,
        sizeBlock.nextSibling
    );

    console.log(
        '✅ EAU Envases: selector colocado después de TAMAÑO'
    );

} else if (intensityBlock && intensityBlock.parentNode) {

    // Respaldo: si no encontramos TAMAÑO,
    // lo colocamos antes de INTENSIDAD
    intensityBlock.parentNode.insertBefore(
        container,
        intensityBlock
    );

    console.log(
        '⚠️ EAU Envases: TAMAÑO no encontrado; colocado antes de INTENSIDAD'
    );

} else if (nativeEnvase && nativeEnvase.parentNode) {

    // Segundo respaldo
    nativeEnvase.parentNode.insertBefore(
        container,
        nativeEnvase
    );

    console.log(
        '⚠️ EAU Envases: colocado antes del selector nativo'
    );

} else {

    // Último recurso
    const form =
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form');

    if (form) {
        form.appendChild(container);

        console.warn(
            '⚠️ EAU Envases: no se encontró TAMAÑO; colocado al final del formulario'
        );
    }
}


            renderSelector(
                container
            );

        } finally {

            state.rendering =
                false;
        }
    }

    // ============================================================
    // 10. RENDERIZAR SELECTOR
    // ============================================================

    function renderSelector(
        container
    ) {

        if (
            !isSupportedCategory()
        ) {

            return;
        }

        if (!container) {
            return;
        }

        state.size =
            detectSize();

        state.concentration =
            detectConcentration();

        const detectedEnvase =
            detectEnvase();

        if (
            detectedEnvase
        ) {

            state.envase =
                detectedEnvase;
        }

        releaseVideos(
            container
        );

        container.innerHTML =
            '';

        // --------------------------------------------------------
        // ENCABEZADO
        // --------------------------------------------------------

        const heading =
            document.createElement(
                'div'
            );

        heading.className =
            'eau-envase-heading';

        const title =
            document.createElement(
                'div'
            );

        title.className =
            'eau-envase-title';

        title.textContent =
            'ELIGE TU ENVASE';

        const subtitle =
            document.createElement(
                'div'
            );

        subtitle.className =
            'eau-envase-subtitle';

        subtitle.textContent =
            'Elige el modelo que prefieras';

        heading.appendChild(
            title
        );

        heading.appendChild(
            subtitle
        );

        container.appendChild(
            heading
        );

        // --------------------------------------------------------
        // SI NO HAY TAMAÑO
        // --------------------------------------------------------

        if (!state.size) {

            const message =
                document.createElement(
                    'div'
                );

            message.className =
                'eau-envase-message';

            message.textContent =
                'Primero selecciona el tamaño del perfume.';

            container.appendChild(
                message
            );

            return;
        }

        // --------------------------------------------------------
        // UNISEX
        // --------------------------------------------------------

        if (
            state.category ===
            'unisex'
        ) {

            const genderBox =
                document.createElement(
                    'div'
                );

            genderBox.className =
                'eau-envase-gender';

            // FEMENINO

            const female =
                document.createElement(
                    'button'
                );

            female.type =
                'button';

            female.className =
                'eau-gender-button';

            female.textContent =
                'Femenino';

            if (
                state.gender ===
                'dama'
            ) {

                female.classList.add(
                    'active'
                );
            }

            female.addEventListener(
                'click',
                function (event) {

                    event.preventDefault();

                    event.stopPropagation();

                    if (
                        state.gender ===
                        'dama'
                    ) {

                        return;
                    }

                    state.gender =
                        'dama';

                    state.envase =
                        null;

                    createSelector();

                    hideNativeEnvase();
                }
            );

            // MASCULINO

            const male =
                document.createElement(
                    'button'
                );

            male.type =
                'button';

            male.className =
                'eau-gender-button';

            male.textContent =
                'Masculino';

            if (
                state.gender ===
                'caballero'
            ) {

                male.classList.add(
                    'active'
                );
            }

            male.addEventListener(
                'click',
                function (event) {

                    event.preventDefault();

                    event.stopPropagation();

                    if (
                        state.gender ===
                        'caballero'
                    ) {

                        return;
                    }

                    state.gender =
                        'caballero';

                    state.envase =
                        null;

                    createSelector();

                    hideNativeEnvase();
                }
            );

            genderBox.appendChild(
                female
            );

            genderBox.appendChild(
                male
            );

            container.appendChild(
                genderBox
            );

            if (!state.gender) {

                const message =
                    document.createElement(
                        'div'
                    );

                message.className =
                    'eau-envase-message';

                message.textContent =
                    'Selecciona Femenino o Masculino.';

                container.appendChild(
                    message
                );

                return;
            }
        }

        // --------------------------------------------------------
        // OBTENER VIDEOS
        // --------------------------------------------------------

        const videos =
            getCurrentVideos();

        if (!videos.length) {

            const message =
                document.createElement(
                    'div'
                );

            message.className =
                'eau-envase-message';

            message.textContent =
                'No hay modelos disponibles para este tamaño.';

            container.appendChild(
                message
            );

            return;
        }

        // --------------------------------------------------------
        // GRID
        // --------------------------------------------------------

        const grid =
            document.createElement(
                'div'
            );

        grid.className =
            'eau-envase-grid';

        // --------------------------------------------------------
        // TARJETAS
        // --------------------------------------------------------

        videos.forEach(
            function (
                videoData,
                index
            ) {

                const envase =
                    'modelo-' +
                    (index + 1);

                const card =
                    document.createElement(
                        'button'
                    );

                card.type =
                    'button';

                card.className =
                    'eau-envase-card';

                card.dataset.envase =
                    envase;

                if (
                    state.envase ===
                    envase
                ) {

                    card.classList.add(
                        'selected'
                    );
                }

                // VIDEO

                const video =
                    document.createElement(
                        'video'
                    );

                video.dataset.src =
                    videoData.src;

                preparePreviewVideo(
                    video
                );

                video.addEventListener(
                    'mouseenter',
                    function () {

                        loadAndPlayVideo(
                            video
                        );

                        pauseOtherVideos(
                            video
                        );
                    }
                );

                video.addEventListener(
                    'focus',
                    function () {

                        loadAndPlayVideo(
                            video
                        );

                        pauseOtherVideos(
                            video
                        );
                    }
                );

                // CHECK

                const check =
                    document.createElement(
                        'span'
                    );

                check.className =
                    'eau-envase-check';

                check.textContent =
                    '✓';

                // NOMBRE

                const name =
                    document.createElement(
                        'div'
                    );

                name.className =
                    'eau-envase-card-name';

                name.textContent =
                    'Modelo ' +
                    (index + 1);

                // ARMAR TARJETA

                card.appendChild(
                    video
                );

                card.appendChild(
                    check
                );

                card.appendChild(
                    name
                );

                // CLIC

                card.addEventListener(
    'click',
    function (event) {

        event.preventDefault();
        event.stopPropagation();

        console.log(
            '🎯 Cliente seleccionó:',
            envase
        );


        // ============================================================
        // 1. MARCAR VISUALMENTE ESTA TARJETA
        // ============================================================

        document
            .querySelectorAll(
                '.eau-envase-card'
            )
            .forEach(
                function (item) {

                    item.classList.remove(
                        'selected'
                    );

                }
            );

        card.classList.add(
            'selected'
        );


        // ============================================================
        // 2. CAMBIAR LA VARIANTE SHOPIFY
        // ============================================================

        selectEnvase(
            envase
        );


        // ============================================================
        // 3. VOLVER A FORZAR EL CHECK
        //    después de que Shopify procese el cambio
        // ============================================================

        setTimeout(
            function () {

                document
                    .querySelectorAll(
                        '.eau-envase-card'
                    )
                    .forEach(
                        function (item) {

                            item.classList.remove(
                                'selected'
                            );

                        }
                    );

                card.classList.add(
                    'selected'
                );

            },
            200
        );


        setTimeout(
            function () {

                document
                    .querySelectorAll(
                        '.eau-envase-card'
                    )
                    .forEach(
                        function (item) {

                            item.classList.remove(
                                'selected'
                            );

                        }
                    );

                card.classList.add(
                    'selected'
                );

            },
            500
        );


        // ============================================================
        // 4. VIDEO
        // ============================================================

        loadAndPlayVideo(
            video
        );

        pauseOtherVideos(
            video
        );

    }
);

                grid.appendChild(
                    card
                );
            }
        );

        container.appendChild(
            grid
        );

        // --------------------------------------------------------
        // REPRODUCIR VIDEO SELECCIONADO
        // --------------------------------------------------------

        let selectedVideo =
            null;

        if (
            state.envase
        ) {

            selectedVideo =
                grid.querySelector(
                    '.eau-envase-card[data-envase="' +
                    state.envase +
                    '"] video'
                );
        }

        if (!selectedVideo) {

            selectedVideo =
                grid.querySelector(
                    'video'
                );
        }

        if (
            selectedVideo
        ) {

            loadAndPlayVideo(
                selectedVideo
            );
        }
    }

    // ============================================================
    // 11. ACTUALIZAR TARJETAS
    // ============================================================

    function updateCards() {

    document
        .querySelectorAll(
            '.eau-envase-card'
        )
        .forEach(
            function (card) {

                const cardEnvase =
                    normalize(
                        card.dataset.envase
                    );

                const currentEnvase =
                    normalize(
                        state.envase
                    );

                card.classList.toggle(
                    'selected',
                    cardEnvase ===
                    currentEnvase
                );
            }
        );
}

    // ============================================================
    // 12. CAMBIO DE TAMAÑO / CONCENTRACIÓN
    // ============================================================

    function refreshAfterSizeChange() {

    clearTimeout(
        state.refreshTimer
    );

    state.refreshTimer =
        setTimeout(
            function () {

                if (
                    !isSupportedCategory()
                ) {
                    return;
                }

                // ==========================================
                // LA VARIANTE REAL DE SHOPIFY ES LA FUENTE
                // ==========================================

                const variant =
                    getCurrentVariant();

                if (!variant) {
                    return;
                }

                const sizeIndex =
                    getOptionIndex(
                        'Tamaño'
                    );

                const envaseIndex =
                    getOptionIndex(
                        'Envase'
                    );

                const concentrationIndex =
                    getOptionIndex(
                        'Concentración del perfume'
                    );

                const newSize =
                    sizeIndex >= 0
                        ? variant[
                            'option' +
                            (sizeIndex + 1)
                        ]
                        : null;

                const newEnvaseValue =
                    envaseIndex >= 0
                        ? variant[
                            'option' +
                            (envaseIndex + 1)
                        ]
                        : null;

                const newConcentration =
                    concentrationIndex >= 0
                        ? variant[
                            'option' +
                            (concentrationIndex + 1)
                        ]
                        : null;

                // ==========================================
                // CONVERTIR MODELO 1 → modelo-1
                // ==========================================

                let newEnvase =
                    null;

                const cleanEnvase =
                    normalize(
                        newEnvaseValue
                    );

                if (
                    cleanEnvase ===
                    'modelo1'
                ) {

                    newEnvase =
                        'modelo-1';

                } else if (
                    cleanEnvase ===
                    'modelo2'
                ) {

                    newEnvase =
                        'modelo-2';

                } else if (
                    cleanEnvase ===
                    'modelo3'
                ) {

                    newEnvase =
                        'modelo-3';
                }

                // ==========================================
                // COMPROBAR QUÉ CAMBIÓ
                // ==========================================

                const sizeChanged =
                    normalize(
                        newSize
                    ) !==
                    normalize(
                        state.size
                    );

                const concentrationChanged =
                    normalize(
                        newConcentration
                    ) !==
                    normalize(
                        state.concentration
                    );

                // ==========================================
                // ACTUALIZAR ESTADO
                // ==========================================

                state.size =
                    newSize;

                state.envase =
                    newEnvase;

                state.concentration =
                    newConcentration;

                // ==========================================
                // SI CAMBIÓ TAMAÑO O CONCENTRACIÓN:
                // RECREAR VIDEOS
                // ==========================================

                if (
                    sizeChanged ||
                    concentrationChanged
                ) {

                    console.log(
                        '🔄 Reconstruyendo selector:',
                        {
                            tamaño:
                                newSize,

                            envase:
                                newEnvaseValue,

                            concentración:
                                newConcentration
                        }
                    );

                    createSelector();

                    hideNativeEnvase();

                    return;
                }

                // ==========================================
                // SI SOLO CAMBIÓ ENVASE:
                // NO RECREAR VIDEOS
                // ==========================================

                updateCards();

            },
            150
        );
}

    // ============================================================
    // 13. ESCUCHAR TAMAÑO
    // ============================================================

    function installSizeListener() {

        document.addEventListener(
            'click',
            function (event) {

                const target =
                    event.target;

                if (
                    !target ||
                    !target.closest
                ) {

                    return;
                }

                const sizeItem =
                    target.closest(
                        '[data-opname="tamaño"] li, ' +
                        '[data-opname="tamano"] li'
                    );

                if (
                    sizeItem
                ) {

                    refreshAfterSizeChange();
                }

            },
            true
        );

        document.addEventListener(
            'change',
            function (event) {

                const target =
                    event.target;

                if (!target) {
                    return;
                }

                let isSizeSelect =
                    false;

                const wrapper =
                    target.closest &&
                    target.closest(
                        '[data-opname]'
                    );

                if (
                    wrapper
                ) {

                    const optionName =
                        normalize(
                            wrapper.getAttribute(
                                'data-opname'
                            )
                        );

                    if (
                        optionName ===
                        'tamano'
                    ) {

                        isSizeSelect =
                            true;
                    }
                }

                if (
                    !isSizeSelect &&
                    target.matches &&
                    target.matches(
                        'select'
                    )
                ) {

                    const dataId =
                        target.getAttribute(
                            'data-id'
                        );

                    const index =
                        getOptionIndex(
                            'Tamaño'
                        );

                    if (
                        dataId !== null &&
                        String(dataId) ===
                        String(index)
                    ) {

                        isSizeSelect =
                            true;
                    }
                }

                if (
                    isSizeSelect
                ) {

                    refreshAfterSizeChange();
                }

            },
            true
        );
    }

    // ============================================================
// 14. ESCUCHAR VARIANTE SHOPIFY
// ============================================================

function installChangeListener() {

    document.addEventListener(
        'change',
        function (event) {

            const target =
                event.target;

            if (
                !target ||
                !target.matches ||
                !target.matches(
                    'select[name="id"]'
                )
            ) {
                return;
            }

            setTimeout(
                function () {

                    if (
                        !isSupportedCategory()
                    ) {
                        return;
                    }

                    // ====================================================
                    // VARIANTE REAL DE SHOPIFY
                    // ====================================================

                    const variant =
                        getCurrentVariant();

                    if (!variant) {
                        return;
                    }

                    const sizeIndex =
                        getOptionIndex(
                            'Tamaño'
                        );

                    const envaseIndex =
                        getOptionIndex(
                            'Envase'
                        );

                    const concentrationIndex =
                        getOptionIndex(
                            'Concentración del perfume'
                        );


                    // ====================================================
                    // OBTENER VALORES DE LA VARIANTE
                    // ====================================================

                    const newSize =
                        sizeIndex >= 0
                            ? variant[
                                'option' +
                                (sizeIndex + 1)
                            ]
                            : null;

                    const newEnvaseValue =
                        envaseIndex >= 0
                            ? variant[
                                'option' +
                                (envaseIndex + 1)
                            ]
                            : null;

                    const newConcentration =
                        concentrationIndex >= 0
                            ? variant[
                                'option' +
                                (concentrationIndex + 1)
                            ]
                            : null;


                    // ====================================================
                    // CONVERTIR ENVASE
                    // ====================================================

                    let newEnvase =
                        null;

                    const cleanEnvase =
                        normalize(
                            newEnvaseValue
                        );

                    if (
                        cleanEnvase ===
                        'modelo1'
                    ) {

                        newEnvase =
                            'modelo-1';

                    } else if (
                        cleanEnvase ===
                        'modelo2'
                    ) {

                        newEnvase =
                            'modelo-2';

                    } else if (
                        cleanEnvase ===
                        'modelo3'
                    ) {

                        newEnvase =
                            'modelo-3';
                    }


                    // ====================================================
                    // ¿CAMBIÓ EL TAMAÑO?
                    // ====================================================

                    const sizeChanged =
                        normalize(
                            newSize
                        ) !==
                        normalize(
                            state.size
                        );


                    // ====================================================
                    // GUARDAR ESTADO
                    // ====================================================

                    state.size =
                        newSize;

                    state.envase =
                        newEnvase;

                    state.concentration =
                        newConcentration;


                    // ====================================================
                    // SI CAMBIÓ EL TAMAÑO:
                    // RECREAR LOS VIDEOS
                    // ====================================================

                    if (
                        sizeChanged
                    ) {

                        console.log(
                            '📏 Cambio de tamaño detectado:',
                            newSize
                        );

                        createSelector();

                        hideNativeEnvase();

                        return;
                    }


                    // ====================================================
                    // SI NO CAMBIÓ EL TAMAÑO:
                    // SOLO ACTUALIZAR CHECK
                    // ====================================================

                    updateCards();


                    // ====================================================
                    // DIAGNÓSTICO
                    // ====================================================

                    console.log(
                        '🔄 Variante Shopify detectada:',
                        {
                            id:
                                variant.id,

                            tamaño:
                                newSize,

                            envase:
                                newEnvaseValue,

                            concentración:
                                newConcentration
                        }
                    );

                },
                80
            );

        },
        true
    );
}

    // ============================================================
    // 15. DIAGNÓSTICO
    // ============================================================

    function diagnose() {

        console.group(
            '🔍 EAU Envases'
        );

        console.log(
            'Tipo producto:',
            state.productData?.productType
        );

        console.log(
            'Categoría:',
            state.category
        );

        console.log(
            'Tamaño:',
            state.size
        );

        console.log(
            'Envase:',
            state.envase
        );

        console.log(
            'Concentración:',
            state.concentration
        );

        console.log(
            'Género:',
            state.gender
        );

        const selector =
            document.getElementById(
                'eau-envase-selector'
            );

        console.log(
            'Selector personalizado:',
            selector
                ? 'ACTIVO'
                : 'NO activo'
        );

        console.groupEnd();
    }

    // ============================================================
    // 16. INICIALIZACIÓN
    // ============================================================

    function init() {

        if (
            state.initialized
        ) {

            return;
        }

        state.productData =
            getProductData();

        if (
            !state.productData
        ) {

            console.warn(
                '⏳ Esperando datos del producto...'
            );

            setTimeout(
                init,
                500
            );

            return;
        }

        state.category =
            getActiveCategory();

        state.size =
            detectSize();

        state.envase =
            detectEnvase();

        state.concentration =
            detectConcentration();

        console.log(
            '📦 Estado inicial:',
            {
                category:
                    state.category,

                size:
                    state.size,

                envase:
                    state.envase,

                concentration:
                    state.concentration
            }
        );

        createStyles();

        // --------------------------------------------------------
        // SOLO PERFUMES
        // --------------------------------------------------------

        if (
            isSupportedCategory()
        ) {

            createSelector();

            hideNativeEnvase();

        } else {

            // Cualquier otro producto:
            // NO selector y Envase normal.
            restoreNativeEnvase();
        }

        installSizeListener();

        installChangeListener();

        setTimeout(
            function () {

                if (
                    isSupportedCategory()
                ) {

                    hideNativeEnvase();

                    refreshAfterSizeChange();

                } else {

                    restoreNativeEnvase();
                }

            },
            300
        );

        setTimeout(
            function () {

                if (
                    isSupportedCategory()
                ) {

                    hideNativeEnvase();

                } else {

                    restoreNativeEnvase();
                }

            },
            1000
        );

        setTimeout(
            function () {

                if (
                    isSupportedCategory()
                ) {

                    hideNativeEnvase();

                } else {

                    restoreNativeEnvase();
                }

            },
            2000
        );

        state.initialized =
            true;

        console.log(
            '✅ EAU Envases listo'
        );

        setTimeout(
            diagnose,
            800
        );
    }

    // ============================================================
    // 17. API GLOBAL
    // ============================================================

    window.EnvaseVideos = {

        init:
            init,

        refresh:
            function () {

                state.productData =
                    getProductData();

                state.category =
                    getActiveCategory();

                state.size =
                    detectSize();

                state.envase =
                    detectEnvase();

                state.concentration =
                    detectConcentration();

                createStyles();

                if (
                    isSupportedCategory()
                ) {

                    createSelector();

                    hideNativeEnvase();

                } else {

                    const existing =
                        document.getElementById(
                            'eau-envase-selector'
                        );

                    if (existing) {

                        releaseVideos(
                            existing
                        );

                        existing.remove();
                    }

                    restoreNativeEnvase();
                }

                setTimeout(
                    function () {

                        if (
                            isSupportedCategory()
                        ) {

                            hideNativeEnvase();

                        } else {

                            restoreNativeEnvase();
                        }

                    },
                    300
                );
            },

        getCategory:
            getActiveCategory,

        getState:
            function () {

                return {

                    productData:
                        state.productData,

                    productType:
                        state.productData?.productType,

                    category:
                        state.category,

                    size:
                        state.size,

                    envase:
                        state.envase,

                    concentration:
                        state.concentration,

                    gender:
                        state.gender
                };
            },

        selectEnvase:
            selectEnvase,

        diagnose:
            diagnose,

        setGender:
            function (gender) {

                if (
                    !isSupportedCategory() ||
                    state.category !==
                    'unisex'
                ) {

                    return;
                }

                if (
                    gender !== 'dama' &&
                    gender !== 'caballero'
                ) {

                    return;
                }

                state.gender =
                    gender;

                state.envase =
                    null;

                createSelector();

                hideNativeEnvase();
            },

        listVideos:
            function () {

                console.log(
                    getCurrentVideos()
                );
            }
    };

    // ============================================================
    // 18. INICIAR
    // ============================================================

    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            init
        );

    } else {

        init();
    }

})();